import AirDatepicker from 'air-datepicker';
import 'air-datepicker/air-datepicker.css';

const isValidDate = (searchDate) => {
  if (!searchDate){ 
    return false
  };
  if (!/^\d{4}-\d{2}-\d{2}$/.test(searchDate)) {
    return false
  };

  const [year, month, day] = searchDate.split('-').map(Number);
  const date = new Date(searchDate);

  return (
    date.getFullYear() === year &&
    date.getMonth() + 1 === month && // JS місяці з 0
    date.getDate() === day
  );
}

export const currenciesDateSelector = (onConvert) => {
  const dateEl = document.querySelector('.date-select');
  const dateInputEl = dateEl.querySelector('span');
  const datePickerEl = document.querySelector('.datepicker-currency');

  const url = new URL(window.location.href);

  const initialDate = isValidDate(url.searchParams.get('date')) ? new Date(url.searchParams.get('date')) : new Date();

  const localeRu = {
    days: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
    daysShort: ['Вос', 'Пон', 'Вто', 'Сре', 'Чет', 'Пят', 'Суб'],
    daysMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
    monthsShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
    today: 'Сегодня',
    clear: 'Очистить',
    dateFormat: 'dd.MM.yyyy',
    timeFormat: 'HH:mm',
    firstDay: 1
  }

  const localeUk = {
    days: ['Неділя', 'Понеділок', 'Вівторок', 'Середа', 'Четвер', 'П’ятниця', 'Субота'],
    daysShort: ['Нед', 'Пнд', 'Вів', 'Срд', 'Чтв', 'Птн', 'Сбт'],
    daysMin: ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    months: ['Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень', 'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень'],
    monthsShort: ['Січ', 'Лют', 'Бер', 'Кві', 'Тра', 'Чер', 'Лип', 'Сер', 'Вер', 'Жов', 'Лис', 'Гру'],
    today: 'Сьогодні',
    clear: 'Очистити',
    dateFormat: 'dd.MM.yyyy',
    timeFormat: 'HH:mm',
    firstDay: 1
  };

  const localeEn = {
    days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    today: 'Today',
    clear: 'Clear',
    dateFormat: 'MM/dd/yyyy',
    timeFormat: 'HH:mm',
    firstDay: 1
  };

  const pickerTranslations = {
    ru: localeRu,
    uk: localeUk,
    en: localeEn
  }

  const picker = new AirDatepicker('#date', {
    inline: true,
    selectedDates: [initialDate],
    // 30 January 2023
    minDate: new Date(1675082950428),
    maxDate: new Date(),
    locale: pickerTranslations[window.locale],
    prevHtml: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.5 15.833L6.66667 9.99967L12.5 4.16634" stroke="#2D2D2D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    `,
    nextHtml: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.5 15.833L13.3333 9.99967L7.5 4.16634" stroke="#2D2D2D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    `,
    onSelect: ({ date }) => {
      datePickerEl.classList.remove('datepicker-currency_open');

      const day = date.getDate(),
        month = date.getMonth() + 1,
        year = date.getFullYear();
      dateInputEl.innerHTML = `${day >= 10 ? day : `0${day}`} ${date.toLocaleString(window.locale, { month: 'short',  year: 'numeric' })}`;

      const dateStr = `${year}-${month >= 10 ? month : `0${month}`}-${day >= 10 ? day : `0${day}`}`;

      // add dateStr to url
      const url = new URL(window.location.href);
      url.searchParams.set('date', dateStr);
      window.history.pushState({}, '', url);

      if(!onConvert) {
         document.querySelectorAll('.rates-table').forEach(table => {
          table.dataset.page = 2;
          fetch(`/api/currencies?date=${dateStr}&type=${table.dataset.tab}`)
            .then(res => res.text())
            .then(html => {
              const tBody = table.querySelector('tbody');
              
              if(tBody) {
                tBody.remove();
              }
              table.insertAdjacentHTML('beforeend', html)
            })
        });
      } else {
        onConvert()
      }
    },
    prevHtml: `
    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7 1L1 7L7 13" stroke="#182840" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
    `,
    nextHtml: `
    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1 13L7 7L1 0.999999" stroke="#182840" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
    `,
    navTitles: {
      days: '<i>MMMM </i> &nbsp; <strong> yyyy</strong> ',
    },
  });

  dateEl.addEventListener('click', () => {
    datePickerEl.classList.add('datepicker-currency_open')
  });

  document.addEventListener('click', (e) => {
    const el = e.target;

    if (el.parentElement.classList.contains('air-datepicker-nav--title')) {
      return
    }

    if (!dateEl.contains(el)) {
      datePickerEl.classList.remove('datepicker-currency_open');
    }
  });

  const day = initialDate.getDate();

  dateInputEl.innerHTML = `${day >= 10 ? day : `0${day}`} ${initialDate.toLocaleString(window.locale, { month: 'short', year: 'numeric' })}`;
}